import React, { FunctionComponent, useState } from 'react';
import { Typography } from '@material-ui/core';
import GenericAccordion from '../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import IAccessoriesCategory from '../../../../../model/accessories/IAccessoriesCategory';
import AccessoriesList from '../accessoriesList/AccessoriesList';
import accessoriesCategoryStyles from './accessoriesCategoryStyles';

export interface IAccessoriesCategoriesProps {
  accessoryCategory: IAccessoriesCategory;
  selectedAccessories: string[];
  onClick: (name: string) => void;
}

const AccessoryCategory: FunctionComponent<IAccessoriesCategoriesProps> = ({
  accessoryCategory,
  onClick,
  selectedAccessories,
}) => {
  const styles = accessoriesCategoryStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <GenericAccordion
      expanded={expanded}
      setExpanded={setExpanded}
      defaultExpanded={false}
      summary={
        <Typography data-test={`accordion:toggle:${accessoryCategory.name}`}>{accessoryCategory.name}</Typography>
      }
      details={
        <AccessoriesList
          selectedAccessories={selectedAccessories}
          accessories={accessoryCategory.accessories}
          onClick={onClick}
        />
      }
      classes={{
        accordionSummary: styles.accordionSummary,
        accordionDetails: styles.accordionDetails,
      }}
      dataTest={`accordion:accessory_category:${accessoryCategory.name.toLowerCase()}`}
    />
  );
};

export default AccessoryCategory;
